import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Button, notification, Statistic } from "antd";
import Layout from "../layout/Layout";
import {
	CustomSearch,
	CustomSpinner,
	CustomTable,
} from "../utils/CustomComponents";
import dayjs from "dayjs";
import { PlusCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import AddMaterialDeliveredModal from "./AddMaterialDeliveredModal";
const { Text } = Typography;

const MaterialDelivered = () => {
	const [loading, setLoading] = useState(false);
	const [loadingTable, setLoadingTable] = useState(false);
	const [addModalOpen, setAddModalOpen] = useState(false);
	const [jobList, setJobList] = useState([]);
	// const [qcUserList, setQCUserList] = useState([]);
	const [startDate, setStartDate] = useState(dayjs());
	const [apiNotification, contextHolder] = notification.useNotification();

	const [refresh, setRefresh] = useState(false);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Material",
			dataIndex: "material",
			key: "material",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Plant",
			dataIndex: "plant",
			key: "plant",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		{
			title: "Total Delivered",
			dataIndex: "totalDelivered",
			key: "totalDelivered",
			render: (value, record) => {
				return (
					<Statistic
						title=""
						value={value}
						suffix={record.measurementUnit}
						precision={2}
						valueStyle={{ fontSize: 14 }}
					/>
				);
			},
		},
		{
			title: "Actions",
			dataIndex: "actions",
			key: "actions",
			render: (_, record) => {
				return (
					<Button
						icon={<DeleteOutlined />}
						size="large"
						onClick={() => deleteMaterial(record.id)}
						type="primary"
						danger
					>
						Delete
					</Button>
				);
			},
		},
	];

	useEffect(() => {
		getMaterials();
	}, [startDate, refresh]);

	const getMaterials = async () => {
		try {
			setLoading(true);
			setLoadingTable(true);

			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;
			const end = `${startDate.year()}-${startDate.month() + 1}-${startDate.date()}`;

			const url =
				api +
				`/materialdelivered/get/list/dates?startDate=${start}&endDate=${end}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						material: item.cog.material,
						plant: item.plant.name,
						totalDelivered: item.quantity,
						measurementUnit: item.measurementUnit,
					});
				});
				setJobList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const deleteMaterial = async (id) => {
		try {
			setLoadingTable(true);

			const url = api + `/materialdelivered/delete/${id}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.delete(url);
			if (data.success) {
				openNotification("success", "Success", data.message);
				setRefresh((prev) => !prev);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<CustomTable columns={columns} data={jobList} loading={loadingTable} />
		);
	};

	const onDateChange = (date) => {
		if (date) {
			setStartDate(date);
		}
	};

	const RenderSearch = () => (
		<Flex gap={10} align="end" justify="space-between">
			<CustomSearch
				loading={loading}
				startDate={startDate}
				dateFormat={"MM/DD/YYYY"}
				onDateChange={onDateChange}
				allowClearDate={false}
			/>
			<Button
				type="primary"
				onClick={() => setAddModalOpen(true)}
				icon={<PlusCircleOutlined />}
				size="large"
				loading={loading}
			>
				Delivered Material
			</Button>
		</Flex>
	);

	const onCloseModal = () => {
		setAddModalOpen(false);
		setRefresh((prev) => !prev);
	};

	return (
		<Layout title="Material Delivered" description="Logistics">
			<Flex vertical gap={16}>
				<RenderSearch />
				{loading ? <CustomSpinner /> : <RenderTable />}
				{contextHolder}
				<AddMaterialDeliveredModal
					key={startDate?.valueOf()}
					addModalOpen={addModalOpen}
					setAddModalOpen={setAddModalOpen}
					onCloseModal={onCloseModal}
					startDate={startDate}
				/>
			</Flex>
		</Layout>
	);
};

export default MaterialDelivered;
